import { render, staticRenderFns } from "./studentAvatar.vue?vue&type=template&id=15d4caa6"
import script from "./studentAvatar.vue?vue&type=script&lang=js"
export * from "./studentAvatar.vue?vue&type=script&lang=js"
import style0 from "./studentAvatar.vue?vue&type=style&index=0&id=15d4caa6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports